import { cn } from '@/lib/utils';
import { useApp, type DeviceFrame as Device } from '@/store/useApp';

const FRAMES: Array<{ id: Device; label: string }> = [
  { id: 'desktop', label: 'Desktop' },
  { id: 'tablet', label: 'Tablet' },
  { id: 'mobile', label: 'Mobile' },
];

export function DeviceFrameSelector() {
  const current = useApp((s) => s.deviceFrame);
  const set = useApp((s) => s.setDeviceFrame);

  return (
    <div
      role="radiogroup"
      aria-label="Device size"
      className="flex items-center rounded-md border border-neutral-200 bg-white p-0.5 dark:border-neutral-800 dark:bg-neutral-950"
    >
      {FRAMES.map((f) => (
        <button
          key={f.id}
          type="button"
          role="radio"
          aria-checked={current === f.id}
          onClick={() => set(f.id)}
          className={cn(
            'rounded px-2 py-0.5 text-[11px] transition-colors',
            current === f.id
              ? 'bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900'
              : 'text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-800',
          )}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
